import React, { Component } from "react";
import { Route, Switch } from "react-router";
import { Prevalidation } from "./Prevalidation";
import { Validation } from "./Validation";
import { Success } from "./Success";
import { FourOhFour } from "../../shared/Components/FourOhFour";

export class App extends Component {
  displayName = App.name;

  render() {
    return (
      <div className="hawaii">
        <Switch>
          <Route
            path="/hi/dentalforhealth/prevalidate"
            component={Prevalidation}
          />
          <Route path="/hi/dentalforhealth/validate" component={Validation} />
          <Route path="/hi/dentalforhealth/success" component={Success} />
          <Route path="*" component={FourOhFour} />
        </Switch>
      </div>
    );
  }
}
